import { apiUrl } from '../lib/build';
import { PRIVATE_MIRROR, tapeOf, type Tape } from '../lib/feedContext';
import type { Meta } from './meta';
import { isUrlName, matchTitle } from './matchTitle';
import { reviewCard, type ReviewLeg } from './review';
import type { FeedRow } from './rows';

export interface SeenLeg extends ReviewLeg {
  link: string;
}

export interface SeenCard {
  forkId: string;
  match: string;
  sport: string;
  market: string;
  roi: string;
  legs: SeenLeg[];
  tape?: Tape;
}

/** Открытая карточка в буфер последних десяти. Ссылка остаётся только в журнале. */
function withLinks(row: FeedRow, legs: ReviewLeg[]): SeenLeg[] {
  return legs.map((leg, index) => {
    const url = row.row.legs[index]?.url ?? '';
    const link = url.startsWith('http://') || url.startsWith('https://') ? url : '';
    return { ...leg, link };
  });
}

export function rememberOpened(row: FeedRow, meta: Meta, fx: number, userId: string | null): void {
  if (PRIVATE_MIRROR || !userId) return;
  const card = reviewCard(row, meta, fx, 'rub');
  const match = (card?.match || matchTitle(row)).trim();
  if (!match || isUrlName(match)) return;
  const plain = card?.legs ?? row.row.legs.slice(0, 2).map((leg) => ({
    book: (meta.venues[leg.source]?.name || leg.source || '').trim(),
    code: leg.source || '',
    side: leg.side.trim(),
    odds: leg.odds || '',
    stake: '',
  }));
  const code = row.row.fork.sport ?? '';
  const body: SeenCard = {
    forkId: row.id,
    match,
    sport: card?.sport || meta.sportNames[code] || row.row.fork.sportName || code,
    market: card?.market || '',
    roi: card?.roi || '',
    legs: withLinks(row, plain),
    tape: tapeOf(typeof location === 'undefined' ? '' : location.pathname),
  };
  void fetch(apiUrl('/v1/reports/seen'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}
